/**
 * Atmosphere palette (VFX-evolution M3) — the djmsqrvve.com "alive forest"
 * colors, ported. The code there is 100% DOM/CSS (not liftable), but the
 * palette + motion timings ARE the vibe, and they transfer wholesale. These
 * hexes are the firefly amber / neon mint / cyan / soft pink / forest greens
 * that read as enchanted.
 */
export const ATMOSPHERE_PALETTE = {
  firefly: 0xffe9a8, // warm amber firefly glow
  amber: 0xffb454, // canopy warmth
  mint: 0x01ffc3, // primary cool neon
  cyan: 0x00e5ff, // bright cyan
  mushroomBlue: 0x00f3ff,
  softPink: 0xff71ce, // magical accent
  leaf: 0x7ec77a,
  moss: 0x1c3a22,
  forest: 0x0a1d12,

  // Biome-ambiance extensions (Gap-Closing Batch 2) — dungeon/cave/volcanic/
  // arctic/underwater zones. Same "alive-but-sparse" intent as the forest set.
  torch: 0xffa53c, // dungeon torch amber
  bone: 0xd8cba8, // dusty temple light
  crystal: 0x66f0ff, // cavern crystal glow
  ember: 0xff7b2e, // volcanic rising ember
  lava: 0xff3814, // volcanic floor heat
  ice: 0xbfe9ff, // arctic pale snow mote
  frostCore: 0x9fd8ff, // arctic cold glow
  deepTeal: 0x1fb6a6, // sunken water caustic
  abyssBlue: 0x123a52, // sunken floor depth

  // Biome Nexus hub — ethereal violet concourse (matches the 🌀 card #a55eea).
  nexusViolet: 0xa55eea, // the Nexus vortex / focal glow
  nexusMote: 0xcdb4ff, // pale violet rising motes

  // Desert — bright sun-bleached arid (the daytime-arid gap; warm GOLD, not volcanic red).
  sand: 0xf4d9a0, // pale sun-bleached sand mote / haze
  dune: 0xd9a85c, // warm tan dune body
  sunHaze: 0xfff2cc, // bright sun bloom + heat haze
  mesa: 0xb5703a, // terracotta rock silhouette

  // Corrupted / Shadowblight — menacing dark-magic void (deeper + dread vs the ethereal Nexus).
  corruptViolet: 0x7d2ae8, // corruption energy core
  witherMagenta: 0xd633ff, // corrupt accent wisp
  blightGlow: 0x9d4dff, // pale corruption glow
  voidCore: 0x140a24, // deep void backdrop (near-black purple)
} as const;

export type AtmospherePaletteKey = keyof typeof ATMOSPHERE_PALETTE;
